import React from "react";
import { isBankTransferPurchaseLocked } from "./bankTransferUtils";

const BankTransferStatusNotice = ({ status }) => {
  if (!status) return null;
  const pending = isBankTransferPurchaseLocked(status);
  const rejected = status.status === "rejected";
  if (!pending && !rejected) return null;

  return (
    <div
      role="status"
      style={{
        width: "100%",
        boxSizing: "border-box",
        padding: "0.9rem 1rem",
        margin: "0.75rem 0",
        borderLeft: `4px solid ${pending ? "#b97900" : "#c73737"}`,
        background: pending ? "#fff8e8" : "#fff1f1",
        color: "#2e2e3a",
        lineHeight: 1.45,
      }}
    >
      <strong>{pending ? "Payment verification pending" : "Payment receipt rejected"}</strong>
      <div style={{ marginTop: "0.2rem", fontSize: "0.9rem" }}>
        {pending
          ? "Your receipt is being reviewed. New purchases are unavailable until the review is complete."
          : `${status.reasonLabel || "We could not verify this payment."}${
              status.remarks ? ` ${status.remarks}` : ""
            } You can submit a new payment now.`}
      </div>
    </div>
  );
};

export default BankTransferStatusNotice;
